import { gqlClient } from 'services/api/gql/gqlClient';
import { RescheduleReservation } from 'constants/gql/mutations/happening/rescheduleReservation.gql';

/**
 * Call RescheduleReservation
 * @param {Object} options - Your object with country, language, activityId, payload, etc.
 * @param {string} oldConfirmationId - Previous confirmation id to reschedule from.
 * @param {Object} [extraHeaders]
 * @returns {Promise<{ newConfirmationId: string } | null>}
 */
const rescheduleAppointment = async (options, oldConfirmationId) => {
    const { language, activityId, payload = {} } = options;

    const {
        clientExternalId,
        isGuestRequest,
        channelId,
        phone,
        reservationPreferences,
        storeId,
        paymentId,
        smsEnabled,
        lastName,
        firstName,
        bookingId,
        startDateTime,
        clientTimeZone,
        featuresToFocusOn,
        baEmployeeNumber,
        specialRequests,
        creditCard,
        pageEncryption
    } = payload;

    const {
        sourceId, brand, cvv, expiryMonth, expiryYear, billTo
    } = creditCard || {};

    const {
        street1, street2, city, country, state, email, firstName: billToFirstName, lastName: billToLastName, postalCode
    } = billTo || {};

    const { pieIntegrityCheck, pieKeyId, piePhaseId, pieMode } = pageEncryption || {};

    const variables = {
        rescheduleReservation: {
            activityId,
            language,
            oldConfirmationId,
            isGuestRequest,
            clientExternalId,
            channelId,
            phone,
            reservationPreferences,
            storeId,
            paymentId,
            smsEnabled,
            lastName,
            firstName,
            bookingId,
            startDateTime,
            clientTimeZone,
            featuresToFocusOn,
            baEmployeeNumber,
            specialRequests,
            country,

            ...(creditCard && {
                creditCard: {
                    sourceId,
                    brand,
                    cvv,
                    expiryMonth,
                    expiryYear,
                    ...(billTo && {
                        billTo: {
                            street1,
                            street2,
                            city,
                            country,
                            state,
                            email,
                            firstName: billToFirstName,
                            lastName: billToLastName,
                            postalCode
                        }
                    })
                }
            }),

            ...(pageEncryption && {
                pageEncryption: {
                    pieIntegrityCheck,
                    pieKeyId,
                    piePhaseId,
                    pieMode
                }
            })
        }
    };

    const gqlOptions = {
        headers: { 'x-source': 'ufe' },
        operationName: 'RescheduleReservation',
        query: RescheduleReservation,
        variables
    };

    const response = await gqlClient.query(gqlOptions);

    return response;
};

export default rescheduleAppointment;
